import * as SwiftypeAppSearch from 'swiftype-app-search-javascript';

export default SwiftypeAppSearch.createClient({
    hostIdentifier: 'host-2wrod6',
    apiKey: 'search-6yovot2cpxdbxgxbjgnn5dtg',
    engineName: 'usa-health-system',
    cacheResponses: false,
});
